/* jshint node:true */
'use strict';

var React           = require('react');
var DateFormatMixin = require('../../../mixins/DateFormatMixin');

var Table = React.createClass({
    render : function(){

        var leagueTable = this.props.table;
        var aLeagueRows = [];
        var subHeading = null;

        if(this.props.name){
            subHeading = (
                <tr>
                    <th colSpan="5">{this.props.name}</th>
                </tr>
            );
        }

        for(var i = 0, len = leagueTable && leagueTable.length; i < len; i++){
            var row = leagueTable[i];
            aLeagueRows.push(
                <tr key={i}>
					<td>{row.position || 0}</td>
					<td><a target="_blank" href={row.href}>{row.name || 0}</a></td>
					<td>{row.played || 0}</td>
					<td>{row.pointsDifference || 0}</td>
					<td>{row.points || 0}</td>
				</tr>
            );
        }

        return (
            <table cellSpacing="0">
                <thead>
                    {subHeading}
                    <tr>
                        <th>POS</th>
                        <th>Team</th>
                        <th>P</th>
                        <th>PD</th>
                        <th>PTS</th>
                    </tr>
                </thead>
                <tbody>
                    { aLeagueRows.length ? aLeagueRows : <tr><td>No data available</td></tr> }
                </tbody>
            </table>
        );
    }
});

var LeagueTable = React.createClass({

    displayName: 'LeagueTable',

    mixins: [DateFormatMixin],

    render: function () {

        var sLeagueTitle    = this.props.name + ' Standings' || '--';
        var sLeagueDate     = this.props.date || '';
        var iLeagueId       = this.props.id || '';
        var aLeagueTable    = this.props.table || [];
        var footer = null;

        if(!aLeagueTable || aLeagueTable.length <= 0){
            return null;
        }

        if(sLeagueDate){
            sLeagueDate = ' <span className="alt">As of ' + this.dateFormat(sLeagueDate,'date1') + '</span>';
        }

        sLeagueTitle += sLeagueDate;

        if(iLeagueId || this.props.tableHref){
            footer = (
                <footer style={{margin:'0'}}>
                    <a data-route='false' target="_blank" href={this.props.tableHref || '/rugby/table/_/league/' + iLeagueId}>Full Table</a>
                </footer>
            );
        }

        return (
            <article className="sub-module">
            	<header>
            		<h1 dangerouslySetInnerHTML={{__html:sLeagueTitle}}></h1>
            	</header>
            	<div className="content">
            		<Table table={aLeagueTable} />
            	</div>
            	{footer}
            </article>
        );
    }
});

module.exports = LeagueTable;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/LeagueTable.jsx
 **/